/*
  FD brand: the "also in the range" drawer.

  The same anatomy as the fabric and comfort drawers -- a collapsed summary row
  that opens a slide-over -- and deliberately the same shell: the scrim, focus
  trap, Escape handling and scroll lock all come from window.FdChooser.shell
  (fd-fabric-drawer.js). There is no second copy of any of that here.

  This is the whole file because there is nothing else to do. The panel is pure
  navigation: every tile is a plain <a> to a sibling product, rendered once by
  Liquid, so there is no draft to hold, nothing to confirm and nothing to
  repaint. No hooks are passed. Turn this file off and the noscript override in
  fd-range-links.liquid puts the same tiles back inline.
*/
(function () {
  'use strict';

  if (customElements.get('fd-range-drawer')) return;

  customElements.define(
    'fd-range-drawer',
    class FdRangeDrawer extends HTMLElement {
      connectedCallback() {
        this.row = this.querySelector('[data-fd-oc-row]');
        this.panel = this.querySelector('.fd-ocpanel');
        this.scrim = this.querySelector('[data-fd-oc-scrim]');
        if (!this.row || !this.panel || !this.scrim || !window.FdChooser) return;

        this.chooser = window.FdChooser.shell(
          { row: this.row, panel: this.panel, scrim: this.scrim },
          {}
        );
      }
    }
  );
})();
